The salary or compensation offered for the position.
